import { render, staticRenderFns } from "./TablePhieuChi.vue?vue&type=template&id=3f8b4f10&scoped=true"
import script from "./TablePhieuChi.vue?vue&type=script&lang=js"
export * from "./TablePhieuChi.vue?vue&type=script&lang=js"
import style0 from "./TablePhieuChi.vue?vue&type=style&index=0&id=3f8b4f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b4f10",
  null
  
)

export default component.exports